import React, { useMemo, useState } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import { useProjectsListingApi } from '../hooks';
import ProjectsTable from './ProjectsTable';
import { useErrorToast } from '../../shared/toast/ToastProvider';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(1, 0, 2, 0),
    },
    searchField: {
        minWidth: 280,
    },
}));

function ProjectsList({ addProject, projectDetails }) {
    const classes = useStyles();
    const [searchTerm, setSearchTerm] = useState('');
    const [{
        data,
        isLoading,
        isError,
    }] = useProjectsListingApi();
    useErrorToast(isError, 'Failed to load projects');

    const handleProjectDetails = (row) => projectDetails(row.code);

    const filteredRows = useMemo(() => {
        if (!searchTerm.trim()) return data;
        const term = searchTerm.trim().toLowerCase();
        return data.filter((r) => (
            (r.code && r.code.toLowerCase().includes(term))
            || (r.name && r.name.toLowerCase().includes(term))
        ));
    }, [data, searchTerm]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <>
            <Typography variant="h4" gutterBottom>PROJECTS</Typography>
            {isLoading && <LinearProgress role="progressbar" />}
            <Box className={classes.toolbar}>
                <TextField
                    className={classes.searchField}
                    label="Search"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Code or name…"
                />
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={addProject}
                >
                    Add New
                </Button>
            </Box>
            <ProjectsTable
                rows={filteredRows}
                details={handleProjectDetails}
                fullHeight
                withoutAddButton
            />
        </>
    );
}

export default ProjectsList;
